module.exports = __webpack_public_path__ + "static/media/nophoto.2ac8b608.png";